import { compareVersion } from './compare-version';

export type ShouldShowWhatsNewParams = {
  contentVersion: string | null;
  currentVersion: string;
  lastLaunchedVersion: string | null;
  lastSeenWhatsNewVersion: string | null;
  accountCreatedAtMs: number | null;
  nowMs: number;
};

const NEW_ACCOUNT_WINDOW_MS = 24 * 60 * 60 * 1000;

const isExistingAccount = (
  accountCreatedAtMs: number | null,
  nowMs: number,
): boolean =>
  accountCreatedAtMs !== null &&
  nowMs - accountCreatedAtMs > NEW_ACCOUNT_WINDOW_MS;

export const shouldShowWhatsNew = ({
  contentVersion,
  currentVersion,
  lastLaunchedVersion,
  lastSeenWhatsNewVersion,
  accountCreatedAtMs,
  nowMs,
}: ShouldShowWhatsNewParams): boolean => {
  if (!contentVersion) {
    return false;
  }

  if (compareVersion(contentVersion, currentVersion) > 0) {
    return false;
  }

  if (
    lastSeenWhatsNewVersion &&
    compareVersion(lastSeenWhatsNewVersion, contentVersion) >= 0
  ) {
    return false;
  }

  if (lastLaunchedVersion) {
    return compareVersion(lastLaunchedVersion, currentVersion) < 0;
  }

  return isExistingAccount(accountCreatedAtMs, nowMs);
};
